// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/workspace/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/workspace/src/app/_layout.tsx"); } },
  "./billing.tsx": { enumerable: true, get() { return require("/workspace/src/app/billing.tsx"); } },
  "./inactive-membership.tsx": { enumerable: true, get() { return require("/workspace/src/app/inactive-membership.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/workspace/src/app/index.tsx"); } },
  "./join.tsx": { enumerable: true, get() { return require("/workspace/src/app/join.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return require("/workspace/src/app/login.tsx"); } },
  "./my-smile.tsx": { enumerable: true, get() { return require("/workspace/src/app/my-smile.tsx"); } },
  "./profile.tsx": { enumerable: true, get() { return require("/workspace/src/app/profile.tsx"); } },
  "./reschedule-perio-appointment.tsx": { enumerable: true, get() { return require("/workspace/src/app/reschedule-perio-appointment.tsx"); } },
  "./schedule-appointment.tsx": { enumerable: true, get() { return require("/workspace/src/app/schedule-appointment.tsx"); } },
  "./verify-login.tsx": { enumerable: true, get() { return require("/workspace/src/app/verify-login.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;